<template>
<section>
	<div class="vehicleSlider couponArea">
		<div class="sCon">
			<strong><span class="hidden">차량정보</span>{{vehicleData.model}}</strong>
			<em><span class="hidden">차대번호</span>{{vehicleData.num_id.substr(0, 10)}}<b>{{vehicleData.num_id.substr(10, 17)}}</b></em>
		</div>
		<button type="button" class="btnToggle" @click="openPopup"></button>
	</div>

	<popup v-if="activate">
		
		<template #title>차량선택</template>
		<template #content>
			<table class="tbl-form alignC pm-tbl-form">
				<tbody>
					<tr v-for="(item, index) in items" :key="index">
						<th>
							<input v-show="false" type="radio" :id="'my_bmw_prime-'+index" :value="index" v-model="selectVehicleItem">
							<label :for="'my_bmw_prime-'+index"><span v-show="false"></span></label>
						</th>
						<td>{{item.model}}({{item.num_reg}})</td>
						<td></td>
					</tr>
				</tbody>
			</table>
		</template>
		<template #button>
			<span><a @click="closePopup(false)">취소</a></span>
			<span><a @click="closePopup(true)" class="fCol1">선택</a></span>
		</template>
	</popup>

</section>
</template>

<script>

// vue components 하나의 루트 요소를 반환해야 한다. 
// 그러므로 section tag로 묶었다.
// but vue-fragments 를 사용하여 하나의 요소로 반환할수있다.
// 적용하지는 않음 
// vue3 에서는 기본기능이다 vue2.X 를 사용시 vue-fragments 사용 

import { VueAgile } from 'vue-agile'
import Popup from '@/components/Popup/Popup.vue'

export default {
  components: {
	agile: VueAgile,
	Popup,
  },
  data() {
	return {
		activate:false,
		selectVehicleItem:null,
	}
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    selected:null
  },
  computed: {
	vehicleData() {
		return this.items[this.selected];
	}
  },
  methods: {
	openPopup() {
		this.selectVehicleItem = this.selected;
		this.activate = true;
	},

	closePopup(submit) {
		if(submit) this.$emit('update:selected', this.selectVehicleItem)
		this.selectVehicleItem = this.selected;
		this.activate = false;
	},
  }
}
</script>

<style>
.sConCustom {
	padding-right:0px !important;
	padding-left:0px !important;
}
</style>